export const COUNT_ADS_PER_PAGE = 20;
